(function() {

	Nette.toggle = function(id, visible, srcElement) {
		var elem = document.getElementById(id);

		if (elem) {
			if (visible) {
				elem.classList.add('js-toggle--visible');
			} else {
				elem.classList.remove('js-toggle--visible');
			}
		}
	};


	Nette.validators.AppReclamationModuleFormRules_isInArray = function(elem, arg, val) {
		return val.indexOf(String(arg)) > -1;
	};

})();
